(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savings-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('savings-product-rail')) {
    customElements.define('savings-product-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ms__track');
        this.controls = this.querySelector('.ms__controls');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.storageKey = 'savings-product-rail:favorites:v1';
        this.favorites = new Set();
        try {
          const saved = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
          if (Array.isArray(saved)) this.favorites = new Set(saved.map(String));
        } catch {}
        this.update = () => {
          const overflow = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = overflow < 2;
          this.previous.disabled = this.track.scrollLeft < 2;
          this.next.disabled = this.track.scrollLeft >= overflow - 2;
        };
        this.renderFavorites = () => {
          this.querySelectorAll('[data-favorite]').forEach(button => {
            const active = this.favorites.has(button.dataset.favorite);
            const label = active ? this.dataset.savedLabel : this.dataset.saveLabel;
            button.setAttribute('aria-pressed', String(active));
            button.setAttribute('aria-label', `${label}: ${button.dataset.productTitle}`);
          });
        };
        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-direction]');
          if (arrow) {
            const card = this.track.firstElementChild;
            if (!card) return;
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
            const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.track.scrollBy({ left: step * Number(arrow.dataset.direction), behavior: reduced ? 'instant' : 'smooth' });
          }
          const favorite = event.target.closest('[data-favorite]');
          if (!favorite) return;
          const key = favorite.dataset.favorite;
          if (this.favorites.has(key)) this.favorites.delete(key); else this.favorites.add(key);
          const keys = [...this.favorites];
          try { localStorage.setItem(this.storageKey, JSON.stringify(keys)); } catch {}
          document.dispatchEvent(new CustomEvent('savings:favorites', { detail: keys }));
          this.querySelector('.ms__status').textContent = `${this.favorites.has(key) ? this.dataset.savedLabel : this.dataset.saveLabel}: ${favorite.dataset.productTitle}`;
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.update);
        }, { passive: true, signal });
        document.addEventListener('savings:favorites', event => {
          this.favorites = new Set(event.detail);
          this.renderFavorites();
        }, { signal });
        window.addEventListener('storage', event => {
          if (event.key !== this.storageKey && event.key !== null) return;
          try {
            const saved = JSON.parse(event.newValue || '[]');
            this.favorites = new Set(Array.isArray(saved) ? saved.map(String) : []);
            this.renderFavorites();
          } catch {}
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const card = event.target.closest('.ms__card');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
        }, { signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.renderFavorites();
        this.frame = requestAnimationFrame(this.update);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serif-zoom-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serif-zoom-gallery')) {
    customElements.define('serif-zoom-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('.szg__dialog');
        this.stage = this.querySelector('[data-szg-stage]');
        this.caption = this.querySelector('[data-szg-caption]');
        this.counter = this.querySelector('[data-szg-counter]');
        this.links = Array.from(this.querySelectorAll('[data-szg-open]'));
        if (!this.dialog) return;
        this.querySelectorAll('[data-szg-step]').forEach(button => { button.hidden = this.links.length < 2; });
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-szg-open]');
          if (trigger) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
            if (typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.opener = trigger;
            this.show(this.links.indexOf(trigger));
            if (!this.dialog.open) {
              this.dialog.showModal();
              const style = document.documentElement.style;
              this.savedOverflow = [style.getPropertyValue('overflow'), style.getPropertyPriority('overflow')];
              style.setProperty('overflow', 'hidden');
            }
            return;
          }
          if (event.target.closest('[data-szg-close]') || event.target === this.dialog) {
            this.dialog.close();
            return;
          }
          const step = event.target.closest('[data-szg-step]');
          if (step) this.show(this.index + Number(step.dataset.szgStep));
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          this.stage.replaceChildren();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }
      show(index) {
        if (!this.links.length) return;
        this.index = (index + this.links.length) % this.links.length;
        const link = this.links[this.index];
        const image = new Image();
        image.alt = link.dataset.alt || '';
        image.decoding = 'async';
        image.width = Number(link.dataset.width);
        image.height = Number(link.dataset.height);
        image.src = link.href;
        this.stage.replaceChildren(image);
        this.caption.textContent = link.dataset.caption || '';
        this.counter.textContent = `${this.index + 1} / ${this.links.length}`;
      }
      unlockScroll() {
        if (!this.savedOverflow) return;
        const style = document.documentElement.style;
        if (this.savedOverflow[0]) style.setProperty('overflow', ...this.savedOverflow);
        else style.removeProperty('overflow');
        this.savedOverflow = null;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-mosaic-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-mosaic-scroll')) {
    customElements.define('social-mosaic-scroll', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.viewport = this.querySelector('[data-smi-viewport]');
        this.track = this.querySelector('[data-smi-track]');
        this.source = this.querySelector('[data-smi-source]');
        this.toggle = this.querySelector('[data-smi-toggle]');
        if (!this.viewport || !this.source) return;
        this.offset = 0; this.distance = 0; this.visible = true;
        this.hovered = false; this.focused = false; this.drag = null;
        this.selected = false; this.userPaused = false;
        this.auto = this.dataset.auto === 'true';
        this.speed = Number(this.dataset.speed) || 30;
        this.direction = this.dataset.direction === 'right' ? -1 : 1;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.reduced.addEventListener('change', () => this.sync(), options);
        this.addEventListener('click', event => {
          if (performance.now() < (this.suppressUntil || 0)) { event.preventDefault(); event.stopPropagation(); return; }
          const step = event.target.closest('[data-smi-step]');
          if (step) this.move(Number(step.dataset.smiStep) * this.stepSize());
          if (event.target.closest('[data-smi-toggle]')) { this.userPaused = !this.userPaused; this.sync(); }
        }, { ...options, capture: true });
        this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && this.dataset.hoverPause === 'true') { this.hovered = true; this.sync(); } }, options);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.viewport.addEventListener('focusin', event => {
          this.focused = event.target.matches(':focus-visible');
          const tile = event.target.closest('.smi__tile');
          if (this.focused && tile && this.source.contains(tile)) { this.offset = tile.offsetLeft; this.paint(); }
          this.sync();
        }, options);
        this.viewport.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.viewport.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); this.sync(); }), options);
        this.viewport.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move((event.key === 'ArrowLeft' ? -1 : 1) * this.stepSize()); }
        }, options);
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        this.viewport.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.drag = { id: event.pointerId, startX: event.clientX, offset: this.offset, moved: false };
          this.sync();
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const delta = event.clientX - this.drag.startX;
          if (!this.drag.moved && Math.abs(delta) > 6) { this.drag.moved = true; this.viewport.setPointerCapture(event.pointerId); this.viewport.setAttribute('data-dragging', ''); }
          if (this.drag.moved) { if (event.cancelable) event.preventDefault(); this.setOffset(this.drag.offset - delta); }
        }, options);
        const release = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          if (this.drag.moved) this.suppressUntil = performance.now() + 300;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.drag = null; this.viewport.removeAttribute('data-dragging'); this.sync();
        };
        this.viewport.addEventListener('pointerup', release, options);
        this.viewport.addEventListener('pointercancel', release, options);
        this.viewport.addEventListener('lostpointercapture', release, options);
        document.addEventListener('pointerup', release, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.addEventListener('shopify:block:select', event => {
          const tile = event.target.closest('.smi__tile');
          if (tile && this.source.contains(tile)) { this.selected = true; this.setOffset(tile.offsetLeft); this.sync(); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.selected = false; this.sync(); }, options);
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.viewport); this.resize.observe(this.source);
        this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.intersection.observe(this);
        this.layout();
      }
      stepSize() { return parseFloat(getComputedStyle(this.source).gridAutoColumns) + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
      layout() {
        const width = this.source.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        if (!width) return;
        this.distance = width + gap;
        this.track.querySelectorAll('[data-smi-clone]').forEach(group => group.remove());
        const count = Math.ceil(this.viewport.clientWidth / this.distance) + 1;
        for (let i = 0; i < count; i++) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-smi-source'); clone.setAttribute('data-smi-clone', ''); clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a').forEach(node => node.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('img').forEach(node => { node.loading = 'lazy'; node.setAttribute('fetchpriority', 'auto'); });
          this.track.append(clone);
        }
        this.setOffset(this.offset); this.sync();
      }
      move(delta) { this.setOffset(this.offset + delta); }
      setOffset(value) { if (this.distance) this.offset = ((value % this.distance) + this.distance) % this.distance; this.paint(); }
      paint() { this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`; }
      sync() {
        cancelAnimationFrame(this.raf); this.raf = 0; this.lastTime = 0;
        if (this.toggle) { this.toggle.hidden = this.reduced.matches; this.toggle.setAttribute('aria-pressed', String(this.userPaused)); this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel); }
        if (!this.isConnected || !this.auto || this.userPaused || this.hovered || this.focused || this.drag || this.selected || !this.visible || document.hidden || this.reduced.matches || !this.distance) return;
        this.raf = requestAnimationFrame(time => this.frame(time));
      }
      frame(time) {
        if (this.lastTime) this.setOffset(this.offset + this.direction * this.speed * Math.min((time - this.lastTime) / 1000, 0.05));
        this.lastTime = time; this.raf = requestAnimationFrame(next => this.frame(next));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.raf); this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
